import React from 'react';
import './EstimatedCostCard.css';

const EstimatedCostCard = ({ price, isLoading = false, label = 'Estimated Cost', basePrice = null }) => {
  const displayText = price === 'Inspection Required' 
    ? 'Inspection Required' 
    : price > 0 
    ? `₹${price.toLocaleString()}` 
    : 'Select service to see price';

  return (
    <div className="cost-card-wrapper" data-testid="estimated-cost-card">
      {/* Floating orbs background effect */}
      <div className="floating-orb orb-1"></div>
      <div className="floating-orb orb-2"></div>
      
      <div className="estimated-cost-card">
        {/* Shimmer effect overlay */}
        <div className="shimmer-overlay"></div>
        
        {/* Glow effect */}
        <div className="card-glow"></div>
        
        {/* Card content */}
        <div className="card-content">
          <div className="cost-label">
            <span className="label-text" data-testid="estimated-cost-label">{label}</span>
            <div className="label-underline"></div>
          </div>
          
          <div className={`cost-value ${isLoading ? 'loading' : ''}`}>
            {isLoading ? (
              <div className="skeleton-loader"></div>
            ) : (
              <>
                <span className="price-text" data-testid="estimated-cost-value">{displayText}</span>
                {price > 0 && price !== 'Inspection Required' && (
                  <div className="pulse-ring"></div>
                )}
              </>
            )}
          </div>
          
          {typeof price === 'number' && price > 0 && (
            <div className="cost-note" data-testid="estimated-cost-note">
              <span className="note-icon">ℹ️</span>
              <span className="note-text">
                {typeof basePrice === 'number' && basePrice > 0 && basePrice !== price
                  ? `Package total based on ₹${basePrice.toLocaleString()} single-service estimate`
                  : 'Final price may vary after inspection'}
              </span>
            </div>
          )}
          
          {price === 'Inspection Required' && (
            <div className="inspection-badge">
              <span className="badge-icon">🔍</span>
              <span className="badge-text">Free inspection included</span>
            </div>
          )}
        </div>
        
        {/* Inner highlight */}
        <div className="inner-highlight"></div>
      </div>
    </div>
  );
};

export default EstimatedCostCard;
